import { Button, Col, Form, Row } from "antd";
import { InputField } from "../../../../../../atoms/FormFields";
import { AutoCompleteField } from "../../../../../../atoms/FormFields/AutoComplete";
import { AddressComponent, Place } from "../../../../../Company/ducks/types";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { SuccessMessage } from "../../../../../../atoms/Toasts/SuccessMessage";
import { AxiosError } from "axios";
import { ErrorMessage } from "../../../../../../atoms/Toasts/ErrorMessage";
import { useAppDispatch } from "../../../../../../config/hooks";
import { getCompanyFieldsById } from "../../../../../CompanySettings/TagsCategories/ducks/actions";
import { getPropertyFormData } from "../../../../ducks/actions";
import { createClient } from "../../../../../Clients/ducks/services";
import { SelectedClientType } from "../../../../ducks/types";

interface PropsType {
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
  companyId: string;
  onClose: () => void;
  data: SelectedClientType | null;
  newClientPopUp?: boolean;
}

interface FormValues {
  name: string;
  address: string;
  type: string;
  category_ids: string;
}

export default function ClientCompany(props: PropsType) {
  const { setLoading, companyId, onClose, data, newClientPopUp } = props;
  const dispatch = useAppDispatch();
  const [googleAddress, setGoogleAddress] = useState<Place | null>(null);
  useEffect(() => {
    if (companyId) {
      const payload = {
        company_id: companyId,
        module: "CLIENTS",
      };

      dispatch(getCompanyFieldsById(payload));
    }
  }, [dispatch, companyId]);

  const {
    control,
    handleSubmit,
    setValue,
    reset,
    formState: { errors },
  } = useForm<FormValues>();

  const onSubmit = (val: FormValues) => {
    setLoading(true);

    let city = "";
    let state = "";
    googleAddress?.address_components?.forEach(
      (component: AddressComponent) => {
        if (component.types.includes("locality")) {
          city = component.long_name;
        }
        if (component.types.includes("administrative_area_level_1")) {
          state = component.short_name;
        }
      }
    );

    const payload = {
      name: val?.name?.trim(),
      address: val?.address,
      city: city,
      state: state,
      type: "company",
      category_ids: val?.category_ids,
      company_id: companyId,
    };

    createClient(payload)
      .then(() => {
        setLoading(false);
        SuccessMessage(newClientPopUp ? "New client added" : "Client updated");
        dispatch(getPropertyFormData(companyId));
        onClose();
      })
      .catch((e: unknown) => {
        if (e instanceof AxiosError) {
          setLoading(false);
          ErrorMessage(
            e?.response?.data?.error?.message ?? "Something went wrong"
          );
        } else {
          setLoading(false);
          ErrorMessage("Something went wrong");
        }
      });
  };

  useEffect(() => {
    if (data && !newClientPopUp) {
      setValue("name", data?.label);
      setValue("address", data?.address);
      setValue("type", data?.type);
    } else {
      reset();
    }
  }, [data, setValue, newClientPopUp, reset]);

  return (
    <Form
      className="propertyForm"
      layout="vertical"
      onFinish={handleSubmit(onSubmit)}
      onKeyDown={(e) => {
        if (e.key === "Enter") e.preventDefault();
      }}
    >
      <Row gutter={8}>
        <Col span={24}>
          <InputField
            fieldName="name"
            label="Company name"
            control={control}
            defaultValue=""
            iProps={{
              placeholder: "Enter name",
            }}
            isRequired
            rules={{
              required: "Company name is required.",
            }}
            validate={errors.name && "error"}
            validMessage={errors.name && errors.name.message}
          />

          <AutoCompleteField
            fieldName="address"
            label="Billing address"
            control={control}
            defaultValue=""
            iProps={{
              placeholder: "Search address",
            }}
            onPlaceChange={(place: Place) => setGoogleAddress(place)}
            tooltipTitle="This is where invoices or payment statements are sent."
          />
        </Col>
        <Col span={24}>
          <div
            className="centered"
            style={{
              paddingTop: "4px",
              display: "flex",
              justifyContent: "flex-end",
              gap: "10px",
            }}
          >
            <Button
              htmlType="button"
              className="outlined-btn"
              onClick={onClose}
            >
              Cancel
            </Button>
            <Button htmlType="submit" type="primary" className="mint-btn">
              Save client
            </Button>
          </div>
        </Col>
      </Row>
    </Form>
  );
}
